export default {
  namespaced: true,
  state: {
    gallery: [
      {
        image: require('@/assets/images/gallery/1.jpg'),
      },
      {
        image: require('@/assets/images/gallery/2.jpg'),
      },
      {
        image: require('@/assets/images/gallery/3.jpg'),
      },
      {
        image: require('@/assets/images/gallery/4.jpg'),
      },
      {
        image: require('@/assets/images/gallery/5.jpg'),
      },
      {
        image: require('@/assets/images/gallery/6.jpg'),
      },
      {
        image: require('@/assets/images/gallery/7.jpg'),
      },
      {
        image: require('@/assets/images/gallery/8.jpg'),
      },
      {
        image: require('@/assets/images/gallery/9.jpg'),
      },
      {
        image: require('@/assets/images/gallery/10.jpg'),
      },
      {
        image: require('@/assets/images/gallery/11.jpg'),
      },
      {
        image: require('@/assets/images/gallery/12.jpg'),
      },
      {
        image: require('@/assets/images/gallery/13.jpg'),
      },
      {
        image: require('@/assets/images/gallery/14.jpg'),
      },
      {
        image: require('@/assets/images/gallery/15.jpg'),
      },
      {
        image: require('@/assets/images/gallery/16.jpg'),
      },
      {
        image: require('@/assets/images/gallery/17.jpg'),
      },
      {
        image: require('@/assets/images/gallery/18.jpg'),
      },
      {
        image: require('@/assets/images/gallery/19.jpg'),
      },
      {
        image: require('@/assets/images/gallery/20.jpg'),
      },
      {
        image: require('@/assets/images/gallery/21.jpg'),
      },
      {
        image: require('@/assets/images/gallery/22.jpg'),
      },
      {
        image: require('@/assets/images/gallery/23.jpg'),
      },
      {
        image: require('@/assets/images/gallery/24.jpg'),
      },
      {
        image: require('@/assets/images/gallery/25.jpg'),
      },
      {
        image: require('@/assets/images/gallery/26.jpg'),
      },
      {
        image: require('@/assets/images/gallery/27.jpg'),
      },
      {
        image: require('@/assets/images/gallery/28.jpg'),
      },
      {
        image: require('@/assets/images/gallery/29.jpg'),
      },
      {
        image: require('@/assets/images/gallery/30.jpg'),
      },
      {
        image: require('@/assets/images/gallery/31.jpg'),
      },
      {
        image: require('@/assets/images/gallery/32.jpg'),
      },
      {
        image: require('@/assets/images/gallery/33.jpg'),
      },
      {
        image: require('@/assets/images/gallery/34.jpg'),
      },
      {
        image: require('@/assets/images/gallery/35.jpg'),
      },
      {
        image: require('@/assets/images/gallery/36.jpg'),
      },
      {
        image: require('@/assets/images/gallery/37.jpg'),
      },
      {
        image: require('@/assets/images/gallery/38.jpg'),
      },
      {
        image: require('@/assets/images/gallery/39.jpg'),
      },
      {
        image: require('@/assets/images/gallery/40.jpg'),
      },
      {
        image: require('@/assets/images/gallery/41.jpg'),
      },
      {
        image: require('@/assets/images/gallery/42.jpg'),
      },
      {
        image: require('@/assets/images/gallery/43.jpg'),
      },
      {
        image: require('@/assets/images/gallery/44.jpg'),
      },
      {
        image: require('@/assets/images/gallery/45.jpg'),
      },
      {
        image: require('@/assets/images/gallery/46.jpg'),
      },
      {
        image: require('@/assets/images/gallery/47.jpg'),
      },
      {
        image: require('@/assets/images/gallery/48.jpg'),
      },
      {
        image: require('@/assets/images/gallery/49.jpg'),
      },
      {
        image: require('@/assets/images/gallery/50.jpg'),
      },
      {
        image: require('@/assets/images/gallery/51.jpg'),
      },
      {
        image: require('@/assets/images/gallery/52.jpg'),
      },
      {
        image: require('@/assets/images/gallery/53.jpg'),
      },
      {
        image: require('@/assets/images/gallery/54.jpg'),
      },
      {
        image: require('@/assets/images/gallery/55.jpg'),
      },
      {
        image: require('@/assets/images/gallery/56.jpg'),
      },
      {
        image: require('@/assets/images/gallery/57.jpg'),
      },
      {
        image: require('@/assets/images/gallery/58.jpg'),
      },
      {
        image: require('@/assets/images/gallery/59.jpg'),
      },
      {
        image: require('@/assets/images/gallery/60.jpg'),
      },
      {
        image: require('@/assets/images/gallery/61.jpg'),
      },
      {
        image: require('@/assets/images/gallery/62.jpg'),
      },
      {
        image: require('@/assets/images/gallery/63.jpg'),
      },
      {
        image: require('@/assets/images/gallery/64.jpg'),
      },
      {
        image: require('@/assets/images/gallery/65.jpg'),
      },
      {
        image: require('@/assets/images/gallery/66.jpg'),
      },
      {
        image: require('@/assets/images/gallery/67.jpg'),
      },
      {
        image: require('@/assets/images/gallery/68.jpg'),
      },
      {
        image: require('@/assets/images/gallery/69.jpg'),
      },
      {
        image: require('@/assets/images/gallery/70.jpg'),
      },
      {
        image: require('@/assets/images/gallery/71.jpg'),
      },
      {
        image: require('@/assets/images/gallery/72.jpg'),
      },
      {
        image: require('@/assets/images/gallery/73.jpg'),
      },
      {
        image: require('@/assets/images/gallery/74.jpg'),
      },
      {
        image: require('@/assets/images/gallery/75.jpg'),
      },
      {
        image: require('@/assets/images/gallery/76.jpg'),
      },
      {
        image: require('@/assets/images/gallery/77.jpg'),
      },
      {
        image: require('@/assets/images/gallery/78.jpg'),
      },
      {
        image: require('@/assets/images/gallery/79.jpg'),
      },
      {
        image: require('@/assets/images/gallery/80.jpg'),
      },
      {
        image: require('@/assets/images/gallery/81.jpg'),
      },
      {
        image: require('@/assets/images/gallery/82.jpg'),
      },
      {
        image: require('@/assets/images/gallery/83.jpg'),
      },
      {
        image: require('@/assets/images/gallery/84.jpg'),
      },
      {
        image: require('@/assets/images/gallery/85.jpg'),
      },
      {
        image: require('@/assets/images/gallery/86.jpg'),
      },
      {
        image: require('@/assets/images/gallery/87.jpg'),
      },
      {
        image: require('@/assets/images/gallery/88.jpg'),
      },
      {
        image: require('@/assets/images/gallery/89.jpg'),
      },
      {
        image: require('@/assets/images/gallery/90.jpg'),
      },
      {
        image: require('@/assets/images/gallery/91.jpg'),
      },
      {
        image: require('@/assets/images/gallery/92.jpg'),
      },
      {
        image: require('@/assets/images/gallery/93.jpg'),
      },
      {
        image: require('@/assets/images/gallery/94.jpg'),
      },
      {
        image: require('@/assets/images/gallery/95.jpg'),
      },
      {
        image: require('@/assets/images/gallery/96.jpg'),
      },
      {
        image: require('@/assets/images/gallery/97.jpg'),
      },
      {
        image: require('@/assets/images/gallery/98.jpg'),
      },
      {
        image: require('@/assets/images/gallery/99.jpg'),
      },
      {
        image: require('@/assets/images/gallery/101.jpg'),
      },
      {
        image: require('@/assets/images/gallery/102.jpg'),
      },
      {
        image: require('@/assets/images/gallery/103.jpg'),
      },
      {
        image: require('@/assets/images/gallery/104.jpg'),
      },
      {
        image: require('@/assets/images/gallery/105.jpg'),
      },
      {
        image: require('@/assets/images/gallery/106.jpg'),
      },
      {
        image: require('@/assets/images/gallery/107.jpg'),
      },
      {
        image: require('@/assets/images/gallery/108.jpg'),
      },
      {
        image: require('@/assets/images/gallery/109.jpg'),
      },
      {
        image: require('@/assets/images/gallery/110.jpg'),
      },
      {
        image: require('@/assets/images/gallery/111.jpg'),
      },
      {
        image: require('@/assets/images/gallery/112.jpg'),
      },
      {
        image: require('@/assets/images/gallery/113.jpg'),
      },
      {
        image: require('@/assets/images/gallery/114.jpg'),
      },
      {
        image: require('@/assets/images/gallery/115.jpg'),
      },
      {
        image: require('@/assets/images/gallery/116.jpg'),
      },
      {
        image: require('@/assets/images/gallery/117.jpg'),
      },
      {
        image: require('@/assets/images/gallery/118.jpg'),
      },
      {
        image: require('@/assets/images/gallery/119.jpg'),
      },
      {
        image: require('@/assets/images/gallery/120.jpg'),
      },
      {
        image: require('@/assets/images/gallery/121.jpg'),
      },
      {
        image: require('@/assets/images/gallery/122.jpg'),
      },
      {
        image: require('@/assets/images/gallery/123.jpg'),
      },
      {
        image: require('@/assets/images/gallery/124.jpg'),
      },
      {
        image: require('@/assets/images/gallery/125.jpg'),
      },
      {
        image: require('@/assets/images/gallery/126.jpg'),
      },
      {
        image: require('@/assets/images/gallery/127.jpg'),
      },
      {
        image: require('@/assets/images/gallery/128.jpg'),
      },
      {
        image: require('@/assets/images/gallery/129.jpg'),
      },
      {
        image: require('@/assets/images/gallery/130.jpg'),
      },
      {
        image: require('@/assets/images/gallery/131.jpg'),
      },
      {
        image: require('@/assets/images/gallery/132.jpg'),
      },
      {
        image: require('@/assets/images/gallery/133.jpg'),
      },
      {
        image: require('@/assets/images/gallery/134.jpg'),
      },
      {
        image: require('@/assets/images/gallery/135.jpg'),
      },
      {
        image: require('@/assets/images/gallery/136.jpg'),
      },
      {
        image: require('@/assets/images/gallery/137.jpg'),
      },
      {
        image: require('@/assets/images/gallery/138.jpg'),
      },
      {
        image: require('@/assets/images/gallery/139.jpg'),
      },
      {
        image: require('@/assets/images/gallery/140.jpg'),
      },
      {
        image: require('@/assets/images/gallery/141.jpg'),
      },
      {
        image: require('@/assets/images/gallery/142.jpg'),
      },
      {
        image: require('@/assets/images/gallery/143.jpg'),
      },
      {
        image: require('@/assets/images/gallery/144.jpg'),
      },
      {
        image: require('@/assets/images/gallery/145.jpg'),
      },
      {
        image: require('@/assets/images/gallery/146.jpg'),
      },
      {
        image: require('@/assets/images/gallery/147.jpg'),
      },
      {
        image: require('@/assets/images/gallery/148.jpg'),
      },
      {
        image: require('@/assets/images/gallery/149.jpg'),
      },
      {
        image: require('@/assets/images/gallery/150.jpg'),
      },
      {
        image: require('@/assets/images/gallery/151.jpg'),
      },
      {
        image: require('@/assets/images/gallery/152.jpg'),
      },
      {
        image: require('@/assets/images/gallery/153.jpg'),
      },
      {
        image: require('@/assets/images/gallery/154.jpg'),
      },
      {
        image: require('@/assets/images/gallery/155.jpg'),
      },
      {
        image: require('@/assets/images/gallery/156.jpg'),
      },
      {
        image: require('@/assets/images/gallery/157.jpg'),
      },
      {
        image: require('@/assets/images/gallery/158.jpg'),
      },
      {
        image: require('@/assets/images/gallery/159.jpg'),
      },
      {
        image: require('@/assets/images/gallery/160.jpg'),
      },
      {
        image: require('@/assets/images/gallery/161.jpg'),
      },
      {
        image: require('@/assets/images/gallery/162.jpg'),
      },
      {
        image: require('@/assets/images/gallery/163.jpg'),
      },
      {
        image: require('@/assets/images/gallery/164.jpg'),
      },
      {
        image: require('@/assets/images/gallery/165.jpg'),
      },
      {
        image: require('@/assets/images/gallery/166.jpg'),
      },
      {
        image: require('@/assets/images/gallery/167.jpg'),
      },
      {
        image: require('@/assets/images/gallery/168.jpg'),
      },
      {
        image: require('@/assets/images/gallery/169.jpg'),
      },
      {
        image: require('@/assets/images/gallery/170.jpg'),
      },
      {
        image: require('@/assets/images/gallery/171.jpg'),
      },
      {
        image: require('@/assets/images/gallery/172.jpg'),
      },
      {
        image: require('@/assets/images/gallery/173.jpg'),
      },
      {
        image: require('@/assets/images/gallery/174.jpg'),
      },
      {
        image: require('@/assets/images/gallery/175.jpg'),
      },
      {
        image: require('@/assets/images/gallery/176.jpg'),
      },
      {
        image: require('@/assets/images/gallery/177.jpg'),
      },
      {
        image: require('@/assets/images/gallery/178.jpg'),
      },
      {
        image: require('@/assets/images/gallery/179.jpg'),
      },
      {
        image: require('@/assets/images/gallery/180.jpg'),
      },
      {
        image: require('@/assets/images/gallery/181.jpg'),
      },
      {
        image: require('@/assets/images/gallery/182.jpg'),
      },
      {
        image: require('@/assets/images/gallery/183.jpg'),
      },
      {
        image: require('@/assets/images/gallery/184.jpg'),
      },
      {
        image: require('@/assets/images/gallery/185.jpg'),
      },
      {
        image: require('@/assets/images/gallery/186.jpg'),
      },
      {
        image: require('@/assets/images/gallery/187.jpg'),
      },
      {
        image: require('@/assets/images/gallery/188.jpg'),
      },
      {
        image: require('@/assets/images/gallery/189.jpg'),
      },
      {
        image: require('@/assets/images/gallery/190.jpg'),
      },
      {
        image: require('@/assets/images/gallery/191.jpg'),
      },
      {
        image: require('@/assets/images/gallery/192.jpg'),
      },
      {
        image: require('@/assets/images/gallery/193.jpg'),
      },
      {
        image: require('@/assets/images/gallery/194.jpg'),
      },
      {
        image: require('@/assets/images/gallery/195.jpg'),
      },
      {
        image: require('@/assets/images/gallery/196.jpg'),
      },
      {
        image: require('@/assets/images/gallery/197.jpg'),
      },
      {
        image: require('@/assets/images/gallery/198.jpg'),
      }
    ],
    showGallery: []
  },
  mutations: {
    SET_GALLERY(state, payload) {
      state.gallery = payload;
    },
    SET_SHOWGALLERY(state, payload) {
      state.showGallery.push(payload);
    },
  },
  actions: {
    showMore ({ commit, getters }) {
      for (let i = 0; i < 6; i++) {
        if (getters.GET_GALLERY.length) {
          commit('SET_SHOWGALLERY', getters.GET_GALLERY.shift())
        }
      }
    },
  },
  getters: {
    GET_GALLERY: (state) => {
      return state.gallery;
    },
    GET_SHOWGALLERY: (state) => {
      return state.showGallery;
    },
  }
};